import { connect } from 'react-redux';
import {
  destroyAccount,
  getAccounts,
  sendAccountInvitation,
  toggleModal,
  toggleSnackBar,
  changeUserAccountType
} from 'state/callers';
import {
  destroyInvitation,
  getInvitations,
  resendInvitation,
  changeInvitationAccountType
} from 'state/callers/invitations';
import {
  getAccountsForUsersTableWithPendingInvitations,
  myAccountSelector
} from 'state/selectors/account';
import Users from './Users';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => ({
  accounts: getAccountsForUsersTableWithPendingInvitations(state),
  myAccount: myAccountSelector(state),
  license: licenseSelector(state),
  isTeamLicense: isTeamLicenseSelector(state)
});

const mapDispatchToProps = {
  toggleModal,
  toggleSnackBar,
  getAccounts,
  getInvitations,
  sendAccountInvitation,
  destroyInvitation,
  destroyAccount,
  resendInvitation,
  changeUserAccountType,
  changeInvitationAccountType
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Users, 'Users Settings'));
